export default "__VITE_ASSET__Boa_i4Cf__"